import ApiClient from '../ApiClient';

class AiAssistThreadsAPI extends ApiClient {
  constructor() {
    super('ai_assist/threads', { accountScoped: true });
  }
}

export default new AiAssistThreadsAPI();
